import { useEffect, useState, type RefObject } from "react";

export function useShorterThan(
	element: RefObject<HTMLElement | null>,
	other: RefObject<HTMLElement | null>
): boolean {
	const [shorter, setShorter] = useState(false);

	useEffect(() => {
		const a = element.current;
		const b = other.current;
		if (!a || !b) return;

		const observer = new ResizeObserver(() => {
			setShorter(a.offsetHeight < b.offsetHeight);
		});
		observer.observe(a);
		observer.observe(b);
		return () => observer.disconnect();
	}, [element, other]);

	return shorter;
}
